/**
 * Shown in place of the app when the visitor's region is geo-blocked.
 * Mirrors the backend's "Service not available in your region." verdict.
 */
export function RegionBlock() {
  return (
    <div className="min-h-screen bg-provny-white text-provny-black flex items-center justify-center px-6">
      <div className="max-w-md text-center">
        <p className="font-heading text-sm uppercase tracking-[0.2em] text-provny-cyber-dim">
          Provny
        </p>
        <h1 className="font-heading mt-6 text-3xl font-semibold leading-tight">
          Not available in your region
        </h1>
        <p className="font-body mt-4 text-provny-muted">
          Provny isn’t available where you are right now. If you believe this is
          a mistake, check back later.
        </p>
      </div>
    </div>
  );
}
